import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-164ff6ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-and-cost-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Work and Cost Center", -1))
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "table-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "WorkCenters", -1))
const _hoisted_6 = {
  key: 0,
  class: "styled-table"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "S. No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "table-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "CostCenters", -1))
const _hoisted_12 = {
  key: 0,
  class: "styled-table"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "S. No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { fetchWorkCenters, fetchCostCenters, deleteFromUrl } from '@/api/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkAndCostCenterView',
  setup(__props) {

const workCenters = ref([]);
const costCenters = ref([]);
const isLoadingWorkCenters = ref(true);
const isLoadingCostCenters = ref(true);
const router = useRouter();

const fetchWorkAndCostCenters = async () => {
  workCenters.value = await fetchWorkCenters();
  costCenters.value = await fetchCostCenters();
  isLoadingWorkCenters.value = false;
  isLoadingCostCenters.value = false;
};

const addWorkCenter = () => {
  router.push("/ops/work-cost-center");
};

const addCostCenter = () => {
  router.push("/ops/work-cost-center");
};

const deleteWorkCenter = async (id) => {
  if (confirm("Are you sure you want to delete this WorkCenter?")) {
    try {
      await deleteFromUrl(`/ops/api/workcenters/${id}/`);
      alert("WorkCenter deleted successfully.");
      await fetchWorkAndCostCenters();
    } catch (error) {
      alert("Failed to delete WorkCenter.");
      console.error("Error deleting WorkCenter:", error);
    }
  }
};

const deleteCostCenter = async (id) => {
  if (confirm("Are you sure you want to delete this CostCenter?")) {
    try {
      await deleteFromUrl(`/ops/api/costcenters/${id}/`);
      alert("CostCenter deleted successfully.");
      await fetchWorkAndCostCenters();
    } catch (error) {
      alert("Failed to delete CostCenter.");
      console.error("Error deleting CostCenter:", error);
    }
  }
};

onMounted(fetchWorkAndCostCenters);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", { class: "title-with-action" }, [
          _hoisted_5,
          _createElementVNode("button", {
            class: "action-button add",
            onClick: addWorkCenter
          }, "➕ Add WorkCenter")
        ]),
        (!isLoadingWorkCenters.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workCenters.value, (workCenter, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `work-${index}`
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(workCenter.name), 1),
                    _createElementVNode("td", null, _toDisplayString(workCenter.description), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "action-button delete",
                        onClick: ($event: any) => (deleteWorkCenter(workCenter.id))
                      }, "Delete", 8, _hoisted_8)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, "Loading WorkCenters..."))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", { class: "title-with-action" }, [
          _hoisted_11,
          _createElementVNode("button", {
            class: "action-button add",
            onClick: addCostCenter
          }, "➕ Add CostCenter")
        ]),
        (!isLoadingCostCenters.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(costCenters.value, (costCenter, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `cost-${index}`
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(costCenter.name), 1),
                    _createElementVNode("td", null, _toDisplayString(costCenter.description), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "action-button delete",
                        onClick: ($event: any) => (deleteCostCenter(costCenter.id))
                      }, "Delete", 8, _hoisted_14)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, "Loading CostCenters..."))
      ])
    ])
  ]))
}
}

})